import type { Currency } from "@/interfaces/currency";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface CountryState {
  currencies: Currency[];
  loading: boolean;
  error: string | null;
}

const initialState: CountryState = {
  currencies: [],
  loading: false,
  error: null,
};

const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    setCurrencies: (state, action: PayloadAction<Currency[]>) => {
      state.currencies = action.payload;
    },

    addCurrency: (state, action: PayloadAction<Currency>) => {
      state.currencies.push(action.payload);
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    clearCurrencies: (state) => {
      state.currencies = [];
    },
  },
});

export const { setCurrencies, addCurrency, setLoading, clearCurrencies } =
  currencySlice.actions;

export default currencySlice.reducer;
